import {FC} from 'react'

import {HEADER_HEIGHT_MOBILE} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Section} from '../common/content/Section'
import {LegalFooter} from './LegalFooter'
import {PreFooter} from './PreFooter'

export const Footer: FC<React.PropsWithChildren<unknown>> = () => (
  <>
    <footer>
      <Section backgroundColor={theme.palette.tertiary.main}>
        <PreFooter />
      </Section>
      <Section
        backgroundColor={theme.palette.tertiary.main}
        hasBorderTop
        borderColor={theme.palette.gray[600]}
      >
        <LegalFooter />
      </Section>
      <div className="footer-offset" />
    </footer>

    <style jsx>{`
      @media ${TABLET_SCREENSIZE} {
        .footer-offset {
          padding-bottom: ${HEADER_HEIGHT_MOBILE};
          background-color: ${theme.palette.tertiary.main};
        }
      }
    `}</style>
  </>
)
